import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './router';
import { ToastProvider } from '@/shared/components/ui/Toast';

function App() {
  return (
    <ToastProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <AppRouter />
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
